import { render, staticRenderFns } from "./formulario-dinamico.vue?vue&type=template&id=3220335a&scoped=true&"
import script from "./formulario-dinamico.vue?vue&type=script&lang=js&"
export * from "./formulario-dinamico.vue?vue&type=script&lang=js&"
import style0 from "./formulario-dinamico.vue?vue&type=style&index=0&id=3220335a&scoped=true&lang=css&"
import style1 from "./formulario-dinamico.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220335a",
  null
  
)

export default component.exports